<template>
  <div class="flex flex-col space-y-5">
    <div>
      <p class="font-medium text-sm">{{ t('auth.profiles.selectProfileType') }}</p>
    </div>
    <div class="flex flex-col space-y-4">
      <MosaicUiButtonsSecondaryButton v-if="allowedProfileTypes.length === 0 || allowedProfileTypes.indexOf('customer') !== -1"
                                      @click="onButtonClicked('customer')"
                                      theme="black"
                                      size="lg"
      >
        <Icon name="fe:user" size="16" />
        {{ t('auth.profiles.types.customer') }}
      </MosaicUiButtonsSecondaryButton>

      <MosaicUiButtonsSecondaryButton v-if="allowedProfileTypes.length === 0 || allowedProfileTypes.indexOf('employee') !== -1"
                                      @click="onButtonClicked('employee')"
                                      theme="black"
                                      size="lg"
      >
        <Icon name="clarity:employee-group-line" size="16" />
        {{ t('auth.profiles.types.employee') }}
      </MosaicUiButtonsSecondaryButton>
    </div>
  </div>
</template>

<script setup lang="ts">
const {t} = useI18n();

const emit = defineEmits(['update:modelValue']);
const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  allowedProfileTypes: {
    type: Array,
    required: true,
    default: [],
  },
});

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value: any) {
    emit('update:modelValue', value);
  }
});

function onButtonClicked(profileType: string) {
  modelValue.value = profileType;
}
</script>

<style scoped>

</style>
